<template>
  <div>
    <v-container class="py-0 px-0" id="hide">
      <v-card tile>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Tanggal"
                  dense
                  small-chips
                  hide-details
                  type="date"
                  v-model="formData.tgl"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-select
                  label="Jenis Kas"
                  v-model="formData.jenis_kas"
                  :items="['masuk', 'keluar']"
                  hide-details
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-combobox
                  v-model="formData.oleh"
                  label="Oleh"
                  :items="items.karyawan"
                  :loading="loading.fetchKaryawan"
                  :disabled="loading.fetchKaryawan"
                  hide-details
                  dense
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Nominal"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="nominal"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-combobox
                  label="Kategori"
                  :items="items.kategori"
                  :loading="loading.fetchKategori"
                  :disabled="loading.fetchKategori"
                  v-model="formData.kategori"
                  dense
                  hide-details
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Untuk Keperluan"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.keperluan"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-combobox
                  v-model="formData.acc"
                  label="ACC"
                  :items="items.karyawan"
                  :loading="loading.fetchKaryawan"
                  :disabled="loading.fetchKaryawan"
                  hide-details
                  dense
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="KC"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.kc"
                  @keydown.enter="saveData"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="1" class="fit-content">
                <v-btn
                  color="primary"
                  :loading="loading.saveData"
                  :disabled="loading.saveData"
                  @click="saveData"
                  small
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- <v-data-table
        :headers="TTPBKembaliHeaders"
        :items="TTPBKembali"
        :loading="loading.TTPBKembali"
        :items-per-page="5"
        class="elevation-1 mt-2"
        dense
      >
        <template v-slot:item.tgl="{ item }">
          {{ formatDate(item.tgl) }}
        </template>
      </v-data-table> -->
    </v-container>

    <main class="report" v-if="receiptData.id" id="section-print">
      <div class="header">
        <div class="left">
          <h6>TANDA TERIMA</h6>
          <p>STRIPPING CONTAINER</p>
        </div>
        <div class="right">
          <p>{{ receiptData.id }}</p>
        </div>
      </div>
      <div class="content">
        <div class="line">
          <p>Tanggal</p>
          <p>{{ formatDate(receiptData.tgl) }}</p>
        </div>
        <div class="line">
          <p>Dikeluarkan Oleh</p>
          <p>{{ receiptData.acc.nama }}</p>
        </div>
        <div class="line">
          <p>Rp</p>
          <p>Rp{{ formatCurrency(Math.abs(receiptData.nominal)) }}</p>
        </div>
        <div class="line">
          <p>Keperluan</p>
          <p>{{ receiptData.keperluan }}</p>
        </div>
      </div>
      <div class="ttd">
        <div>
          <p>Diserahkan Kepada,</p>

          <p class="nama">{{ receiptData.oleh.nama }}</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import { sync } from "vuex-pathify";

export default {
  name: "ContainerModal",
  props: ["openModal"],
  data() {
    return {
      loading: {
        fetchKaryawan: false,
        fetchKategori: false,
        saveData: false
      },
      formData: {
        tgl: "",
        jenis_kas: "",
        oleh: "",
        nominal: 0,
        kategori: "",
        keperluan: "",
        acc: "",
        kc: ""
      },
      TTPBKembaliHeaders: [
        { text: "TTPB", value: "ttpb" },
        { text: "Tanggal", value: "tgl" },
        { text: "Penerima", value: "penerima" },
        { text: "Pengantar", value: "pengantar" },
        { text: "Kondisi", value: "kondisi_penerimaan" },
        { text: "Catatan", value: "catatan" }
      ],
      TTPBKembali: [],
      items: {
        karyawan: [],
        kategori: []
      },
      receiptData: {}
    };
  },
  computed: {
    nominal: {
      get() {
        return this.formatCurrency(this.formData.nominal);
      },
      set(value) {
        return (this.formData.nominal = this.convertToAngka(value));
      }
    }
  },
  watch: {
    "formData.kc"(val) {
      if (val) {
        this.formData.kc = val.toUpperCase();
      }
    }
  },
  methods: {
    async fetchData() {
      this.loading.TTPBKembali = true;

      axios
        .get("ttpb-kembali")
        .then(res => {
          this.TTPBKembali = res.data;

          this.loading.TTPBKembali = false;
        })
        .catch(err => {
          this.loading.TTPBKembali = false;

          alert(err.response.data.message);
        });
    },
    async saveData() {
      this.loading.saveData = true;

      await axios
        .post(`kas/biaya-lain`, this.formData)
        .then(res => {
          this.loading.saveData = false;
          this.receiptData = res.data.data;

          setTimeout(() => {
            window.print();
          }, 500);

          this.fetchKategori();
          // this.resetFormData();
        })
        .catch(err => {
          this.loading.saveData = false;

          alert(err.response.data.message);
        });
    },
    async fetchKaryawan() {
      this.loading.fetchKaryawan = true;

      await axios
        .get(`karyawan`)
        .then(res => {
          this.items.karyawan = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));

          this.loading.fetchKaryawan = false;
        })
        .catch(err => {
          this.loading.fetchKaryawan = false;

          alert(err.response.data.message);
        });
    },
    async fetchKategori() {
      this.loading.fetchKategori = true;

      await axios
        .get(`master-data?kategori=kategori_pengeluaran`)
        .then(res => {
          this.items.kategori = res.data.map(data => data.nama);

          this.loading.fetchKategori = false;
        })
        .catch(err => {
          this.loading.fetchKategori = false;

          alert(err.response.data.message);
        });
    },
    resetFormData() {
      this.formData.tgl = "";
      this.formData.oleh = "";
      this.formData.nominal = "";
      this.formData.kategori = "";
      this.formData.keperluan = "";
      this.formData.acc = "";
      this.formData.kc = "";
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}/${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}/${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai == "0" || nilai == "" || nilai == null) return 0;

      let desimal = nilai.split(",")[1];
      let angka = nilai
        .split(",")[0]
        .split(".")
        .join("");
      return parseFloat(`${angka}.${desimal}`);
    }
  },
  created() {
    this.fetchKaryawan();
    this.fetchKategori();
    // this.fetchData();
  }
};
</script>

<style scoped>
@media print {
  #section-print {
    width: 80mm 300mm;
  }
}

@page {
  size: 80mm 300mm;
}

#section-print {
  display: none;
  font-size: 14px;
  width: 80mm;
  height: 300mm;
}

.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}

.left h6 {
  font-size: 12px;
  text-decoration: underline;
  margin: 0;
  padding: 0;
}

.right p {
  border: 1px solid black;
  padding: 3px 10px;
}

.line {
  display: flex;
  justify-content: space-between;
}

.ttd {
  margin-top: 1rem;
  display: flex;
  justify-content: end;
}

.ttd .nama {
  margin-top: 4rem;
}

@media print {
  #section-print {
    display: inline-block;
  }

  #hide {
    display: none;
  }
}

.fit-content {
  height: fit-content;
}

table thead th {
  font-size: 12px !important;
}

.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.w-100 {
  width: 100%;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.no-wrap {
  white-space: nowrap;
}

.without_ampm::-webkit-datetime-edit-ampm-field {
  display: none;
}

input[type="time"]::-webkit-clear-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -ms-appearance: none;
  appearance: none;
  margin: -10px;
}
</style>
